import { ECountry } from '@portals/help-center-core';
import russianFlag from '@/../public/static/flags/russia.svg';
import chinaFlag from '@/../public/static/flags/china.svg';
import armeniaFlag from '@/../public/static/flags/armenia.svg';
import kazakhstanFlag from '@/../public/static/flags/kazakhstan.svg';
import belarusFlag from '@/../public/static/flags/belarus.svg';
import uzbekistanFlag from '@/../public/static/flags/uzbekistan.svg';
import kyrgyzstanFlag from '@/../public/static/flags/kyrgyzstan.svg';
import georgiaFlag from '@/../public/static/flags/georgia.svg';
import tajikistanFlag from '@/../public/static/flags/tajikistan.svg';

export const getRegionFlag = (value: ECountry): string => {
  switch (value) {
    case ECountry.RUSSIA:
      return russianFlag;
    case ECountry.CHINA:
      return chinaFlag;
    case ECountry.ARMENIA:
      return armeniaFlag;
    case ECountry.KAZAKHSTAN:
      return kazakhstanFlag;
    case ECountry.BELARUS:
      return belarusFlag;
    case ECountry.UZBEKISTAN:
      return uzbekistanFlag;
    case ECountry.KYRGYZSTAN:
      return kyrgyzstanFlag;
    case ECountry.GEORGIA:
      return georgiaFlag;
    case ECountry.TAJIKISTAN:
      return tajikistanFlag;
    default:
      throw new Error(`Forgot to add a region flag for - ${value}`);
  }
};
